import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		activeContainer: {
			position: 'relative',
			// margin: '0 -15px',
			margin: `${theme.spacing(1)}px 0 0 0`,
			padding: 0,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			flex: 1,
			alignSelf: 'stretch',
			cursor: 'pointer',
			'& .fr-box': {
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				// height: '100%',
				flexGrow: 1,
				'& .fr-element': {
					paddingTop: 0,
				},
				'& .fr-placeholder': {
					// paddingTop: '1em!important',
					// paddingBottom: '1em!important',
				},
				'& > .fr-toolbar': {
					// border: 'none',
					backgroundColor: theme.palette.common.white,
					boxShadow: 'none',
					background: 'transparent',
				},
				'& > .fr-wrapper': {
					flexGrow: 1,
					boxShadow: 'none!important',
					background: 'transparent',
				},
			},
			[theme.breakpoints.down('sm')]: {
				// top: 0,
				// left: 0,
				// right: 0,
				// bottom: 0,
				background: '#ffffff',
				// zIndex: 100,
			},
		},
		preview: {
			padding: 16,
			overflow: 'auto',
			[theme.breakpoints.down('sm')]: {
				padding: 8,
			},
		},
		buttonsContainer: {
			flex: 1,
			alignSelf: 'stretch',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			maxHeight: 48,
			'& > button': {
				flex: 1,
				height: theme.spacing(6),
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				color: '#ffffff',
				fontSize: 18,
			},
		},
		saveButton: {
			fontWeight: 700,
			backgroundColor: theme.palette.secondary.main,
		},
	})
